<template>
  <v-autocomplete
    v-model="filter.relatorioAdm"
    item-text="title"
    item-value="id"
    :items="relatorios"
    placeholder="Relatórios Adms"
    multiple
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon
          :color="
            filter.relatorioAdm && filter.relatorioAdm.length > 0
              ? 'indigo darken-4'
              : ''
          "
          >{{ icon }}</v-icon
        >
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <span v-if="index < maxDisplay"
        >{{ item.title
        }}{{
          index === 0 && filter.relatorioAdm && filter.relatorioAdm.length > 1
            ? ","
            : ""
        }}
        &nbsp;</span
      >
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{
          filter.relatorioAdm && filter.relatorioAdm.length - maxDisplay
        }}
        relatórios)</span
      >
    </template>

    <template slot="no-data"> Nenhum relatório retornado </template>
  </v-autocomplete>
</template>

<script>
import { relatorios } from "@/modules/administrative-dashboard/utils/relatorio";

export default {
  name: "AppAxisByProjectCombobox",
  props: ["filter"],
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.relatorioAdm = [];
        } else {
          this.filter.relatorioAdm = this.relatorios
            .slice()
            .map((item) => item.id);
        }
      });
    },
  },
  computed: {
    likesAll() {
      return (
        this.filter.relatorioAdm &&
        this.filter.relatorioAdm.length === this.relatorios.length
      );
    },
    likesSome() {
      return (
        this.filter.relatorioAdm &&
        this.filter.relatorioAdm.length > 0 &&
        !this.relatorios
      );
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  data() {
    return {
      maxDisplay: 2,
      relatorios: relatorios.map((item) => ({
        id: item.id,
        title: item.title,
      })),
    };
  },
};
</script>
